import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M11 8.25v11m0 0a7.333 7.333 0 0 1-7.333-7.333M11 19.25a7.333 7.333 0 0 0 7.333-7.333m.917 0h-1.833m-12.834 0H2.75M8.25 5.5a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h22v22H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }